import React from "react";

const PulseGrowAnimation = () => (
  <style jsx>{`
    @keyframes move-right {
      0%,
      100% {
        transform: translateX(0);
      }
      50% {
        transform: translateX(20px);
      }
    }

    .moving-arrow {
      animation: move-right 1.5s infinite ease-in-out;
    }
  `}</style>
);

function PointingArrow({
  location,
  size = { width: "100px" },
  hidden = false,
  rotate = false,
}) {
  const rotation = rotate ? "rotate-180" : "";
  const classes = "absolute pointer-events-none "
  const classNames = classes.concat(rotation)
  const style = { ...location, ...size };

  if (hidden) return <></>;

  return (
    <div className={classNames} style={style}>
      <PulseGrowAnimation />
      <img
        src="/assets/images/arrow.png"
        alt="arrow"
        className="w-full moving-arrow"
      />
    </div>
  );
}

export default PointingArrow;

